import React from 'react';

const HeroSimple = () => {
  return (
    <section id="hero" className="h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-cyan-800 to-indigo-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-20"></div>
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-10 md:pt-0 pb-2">
        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-2 md:p-8 shadow-2xl border border-white/20">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Левая сторона - информация */}
            <div className="text-white space-y-2 md:space-y-6">
              <h1 className="text-3xl md:text-5xl font-bold">
                Hi, I'm <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-400">Vitaliy Kustov</span>
              </h1>
              
              <p className="text-base text-gray-200">
                Full-Stack Developer & UI/UX Enthusiast
              </p>
              
              <div className="flex flex-wrap gap-2">
                {['React', 'TypeScript', 'Node.js', 'Tailwind CSS', 'PostgreSQL'].map((skill) => (
                  <span
                    key={skill}
                    className="px-2 py-1 bg-gradient-to-r from-blue-600 to-cyan-700 text-white rounded-full text-xs font-medium"
                  >
                    {skill}
                  </span>
                ))}
              </div>

              <div className="flex flex-wrap gap-1">
                <a
                  href="https://github.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-gray-900 px-3 py-1 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg text-xs"
                >
                  GitHub
                </a>
                <a
                  href="https://t.me/hrefxxx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-500 text-white px-3 py-1 rounded-full font-semibold hover:bg-blue-600 transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-1 text-xs"
                >
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3.082-1.231-1.488 1.418c-.276.263-.517.398-.808.398-.497 0-.914-.286-1.084-.508l-1.97-9.28c-.187-.756.063-1.284.648-1.462l9.467-3.658c.583-.224 1.065.056 1.275.674z"/>
                  </svg>
                  Telegram
                </a>
              </div>

              <div className="grid grid-cols-4 gap-1 text-center">
                <div>
                  <div className="text-base font-bold">20+</div>
                  <div className="text-xs text-gray-300">Years</div>
                </div>
                <div>
                  <div className="text-base font-bold">50+</div>
                  <div className="text-xs text-gray-300">Projects</div>
                </div>
                <div>
                  <div className="text-base font-bold">100%</div>
                  <div className="text-xs text-gray-300">Satisfaction</div>
                </div>
                <div>
                  <div className="text-base font-bold">0%</div>
                  <div className="text-xs text-gray-300">Bugs</div>
                </div>
              </div>
            </div>
            
            {/* Правая сторона - фото */}
            <div className="flex justify-center">
              <div className="relative">
                <div className="w-40 h-40 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl border-4 border-white">
                  <img 
                    src="/vk.webp"
                    alt="Vitaliy Kustov" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -inset-4 bg-gradient-to-br from-blue-400 to-cyan-600 rounded-full opacity-10 blur-xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSimple;
